import store from '@/store';
import api, {
  jsonToMultiPartFormData,
  csrfRequest,
  craftError,
  paginate,
} from '@/api';
import log from '@/configured/logger';

const startingActivityMediaUrl = '/api/messages/media';

const exports = {
  namespace: 'activity',
  module: {
    namespaced: true,
    state: {
      viewAs: null,
      activityMediaUrl: startingActivityMediaUrl,
      activityMediaData: [],
    },
    mutations: {
      ADD_ACTIVITY,
      RESET_ACTIVITY,
      SET_VIEW_AS,
      CLEAR_OFFLINE_ACTIVITY_DATA,
    },
    actions: {
      setViewAs,
      loadMediaPage: activityPageLoader('Media'),
      refreshMediaPage: refreshActivityPage('Media'),
      clearOfflineData: ({ commit }) => commit('CLEAR_OFFLINE_ACTIVITY_DATA'),
    },
  },
};

store.registerModule(exports.namespace.split('/'), exports.module);

export default exports;

//////////
function ADD_ACTIVITY(state, { key, data, nextUrl }) {
  const dataKey = `activity${key}Data`;
  const urlKey = `activity${key}Url`;
  if (JSON.stringify(state[dataKey]) !== JSON.stringify(data)) {
    state[dataKey] = state[dataKey].concat(data);
  }
  state[urlKey] = nextUrl;
}

function CLEAR_OFFLINE_ACTIVITY_DATA(state) {
  state.activityMediaData = [];
  state.activityMediaUrl = startingActivityMediaUrl;
}

function RESET_ACTIVITY(state, key) {
  if (key === 'Media') {
    state[`activity${key}Data`] = [];
    state[`activity${key}Url`] = startingActivityMediaUrl;
  }
}

function SET_VIEW_AS(state, viewAs) {
  state.viewAs = viewAs;
}

function setViewAs({ commit, state }, viewAs) {
  if (viewAs && !viewAs.uid) {
    viewAs = null;
  }
  commit('SET_VIEW_AS', viewAs);
  refreshActivityPage('Media')({ commit });
}

function refreshActivityPage(key) {
  return function ({ commit }) {
    log.info('reset');
    commit('RESET_ACTIVITY', key);
    store.dispatch(`${exports.namespace}/load${key}Page`, key);
  };
}

// Returns an action function that will
// load the next page, if possible.
// Returns a promise that resolves to true if there are
// more pages, or false otherwise
function activityPageLoader(key) {
  return ({ state, commit }) => {
    let url = state[`activity${key}Url`];

    if (!url) {
      log.info('No next page or request was already handled');
      return Promise.resolve(false);
    }

    if (state.viewAs) {
      log.info('Adding viewAs to url', url, state.viewAs);
      let newUrl = new URL(url, window.location.origin);
      newUrl.searchParams.append('uid', state.viewAs.uid);
      url = newUrl.toString();
    }

    return paginate(url)
      .then(({ data, nextUrl }) => {
        commit('ADD_ACTIVITY', { key, data, nextUrl });
        return !!nextUrl;
      })
      .catch((error) => {
        if (api.isCancel(error)) {
          log.info(`Caught cancellation for ${endpoint}`);
          return;
        }
        throw error;
      });
  };
}
